import React from 'react'

export const About = () => {
    return (
        <div className="wrapper df">
            <h1>About Page</h1>
        </div>
    )
}


